/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Cmspost_Live_Url1Inputs */

const vi_cmspost_live_url1 = /** @type {(inputs: Cmspost_Live_Url1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang chạy trên web: /tin-tuc/${i?.slug}`)
};

/**

* @param {Cmspost_Live_Url1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_live_url1 = /** @type {((inputs: Cmspost_Live_Url1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Live_Url1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_live_url1(inputs)
});
export { cmspost_live_url1 as "cmsPost_live_url" }